<template>
<div id="auditoria_abonos_cargos" >
  <div>
    <v-breadcrumbs :items="breadcrumbs" >
      <v-icon slot="divider" >forward</v-icon>
    </v-breadcrumbs>
  </div>

  <v-container fluid fill-height>
    <v-row align-center justify-center>
      <v-col xs="12" >
        <base-material-card color="primary" icon="library_books" title="REPORTEADOR DE PORCENTAJES DE RETORNO" class="elevation-1 px-5 py-3" >
          <br>
          <v-tabs grow style="margin-bottom: 30px;" >
            <v-tabs-slider color="primary" ></v-tabs-slider>
            <v-tab :key="'grafica-view'">Gráfica % de Retorno</v-tab>
            <v-tab :key="'grafica-view-destino'">Gráfica Valor Destino Aduanero</v-tab>
            <v-tab :key="'cargos-view'" @click="tipo_div=1; cargar()">Cargos</v-tab>
            <v-tab :key="'abonos_view'" @click="tipo_div=2; cargar()">Abonos</v-tab>

            <v-tab-item :key="'grafica-view'" >
                            <div class="contenedor-tab-reportes">
                              <v-card-text>
                            
                                <v-form ref="form" lazy-validation>
                                  <v-container grid-list-md text-xs-center>
                              
                                    <v-row  dense>
                                      <v-col sm="12" md="2" lg="2" v-if="valoracion!='ULTIMOS 12 MESES'">
                                        
                                        <v-menu offset-x ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                          <template v-slot:activator="{ on }">
                                            <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial Cargos" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'"
                                              :rules="[rules.required, validaAnio, validaFecha]"></v-text-field>
                                          </template>

                                          <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu1 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu1 = false">
                                              Cancelar
                                            </v-btn>
                                          </v-date-picker>
                                        </v-menu>
                                      </v-col>
                                      <v-col sm="12" md="2" lg="2">
                                        <v-menu offset-x ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                          <template v-slot:activator="{ on }">
                                            <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final Cargos" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'"
                                              :rules="[rules.required, validaAnio, validaFecha]"></v-text-field>
                                          </template>
                                          <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu2 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu2 = false">
                                              Cancelar
                                            </v-btn>
                                          </v-date-picker>
                                        </v-menu>

                                      </v-col>
                                      <v-col sm="2" md="2">
                                          <v-autocomplete v-model="model.destinos_cargos" :items="destinos_aduaneros_cargos"  chips small-chips label="Destinos Aduaneros en Cargos" item-text="clave" item-value="clave" multiple />
                                      </v-col>
                                      <v-col cols="12" sm="2" md="2" lg="2" v-if="valoracion!='ULTIMOS 12 MESES'" >
                                        
                                        <v-menu offset-x ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                          <template v-slot:activator="{ on }" >
                                            <v-text-field v-on="on" v-model="model.fecha_de_a" label="Fecha Inicial Abonos" color="secondary" prepend-icon="event" @blur="model.fecha_de_a = parseDate(model.fecha_de_a)" v-mask="'####-##-##'"
                                                :rules="[rules.required, validaAnio, validaFecha]" ></v-text-field>
                                          </template>

                                          <v-date-picker v-model="model.fecha_de_a" color="secondary" scrollable locale="es-mx" @input="menu3 = false" >
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu3 = false" >
                                              Cancelar
                                            </v-btn>
                                          </v-date-picker>
                                        </v-menu>
                                      </v-col>
                                      <v-col cols="12" sm="2" md="2" lg="2" >
                                        <v-menu offset-x ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                          <template v-slot:activator="{ on }" >
                                            <v-text-field v-on="on" v-model="model.fecha_a_a" label="Fecha Final Abonos" color="secondary" prepend-icon="event" @blur="model.fecha_a_a= parseDate(model.fecha_a_a)" v-mask="'####-##-##'"
                                                :rules="[rules.required, validaAnio, validaFecha]" ></v-text-field>
                                          </template>
                                          <v-date-picker v-model="model.fecha_a_a" color="secondary" scrollable locale="es-mx" @input="menu4 = false" >
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu4 = false" >
                                              Cancelar
                                            </v-btn>
                                          </v-date-picker>
                                        </v-menu>

                                      </v-col>
                                      <v-col sm="2" md="2">
                                          <v-autocomplete v-model="model.destinos_abonos" :items="destinos_aduaneros_abonos" chips small-chips label="Destinos Aduaneros en Abonos" item-text="clave" item-value="clave" multiple />
                                      </v-col>
                                    </v-row>
                                    <v-row  dense>
                                          <v-col cols="12" sm="3" md="3">

                                              <v-autocomplete v-model="valoracion" :items="valoraciones" :hide-no-data="true" :return-object="false" item-text="id" item-value="id" label="Modelo de Valoración">
                                              </v-autocomplete>
                                          </v-col>
                                          <v-col v-if="valoracion=='ULTIMOS 12 MESES'" cols="12" sm="3" md="3" >

                                              <v-autocomplete  v-model="presentacion" :items="presentaciones" :hide-no-data="true" :return-object="false" item-text="id" item-value="id" label="Periodo de Presentación">
                                              </v-autocomplete>
                                          </v-col>
                                      
                                          <v-col v-if="planta_referencia"  cols="12" sm="3" md="3">
                                              <v-autocomplete   v-model="planta" label="Planta Referencia" :items="plantas" :hide-no-data="true" item-text="referencia" item-value="referencia" clearable>
                                              </v-autocomplete>
                                          </v-col>
                                          <v-col v-if="!planta_referencia"  cols="12" sm="3" md="3">
                                          </v-col>
                                          <v-col v-if="valoracion!='ULTIMOS 12 MESES'" cols="12" sm="3" md="3" >
                                          </v-col>
                                            <v-col cols="12" sm="3" md="3" style="text-align:right">
                                            
                                              <br />
                                                    <v-btn color="success" @click="consultaPorcentajes">
                                                      <v-icon>done</v-icon>Generar Gráfica
                                                    </v-btn>
                                            </v-col>
                                      </v-row>
                                  
                                  </v-container>

                                </v-form>
                              </v-card-text>
                            
                              <v-card-text>
                              

                           

                            <v-row v-if="data_tableA.length > 0">
                                <v-col lg="6" style="padding-top:10px;">

                                   
                                    <v-client-table style="margin-top:0px;width:100%" ref="vuetableA" :data="data_tableA" :columns="columns_tableA" :options="tableA_options" class="elevation-2 pa-2 footer-hide">
                                        <template slot="noResults">
                                            <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                                        </template>
                                        <template slot="cargos" slot-scope="props">
                                            <div :class="props.row.ejercicio=='TOTAL'?'text-right font-weight-bold':'text-right'"> {{ formatNumber(props.row.cargos)}}</div>
                                        </template>
                                        <template slot="abonos" slot-scope="props">
                                            <div :class="props.row.ejercicio=='TOTAL'?'text-right font-weight-bold':'text-right'"> {{ formatNumber(props.row.abonos)}}</div>
                                        </template>
                                        <template slot="porcentaje" slot-scope="props">
                                            <div :class="props.row.ejercicio=='TOTAL'?'text-right font-weight-bold':'text-right'"> {{ formatNumber(props.row.porcentaje,2)}} %</div>
                                        </template>
                                        <template slot="ejercicio" slot-scope="props">
                                            <div :class="props.row.ejercicio=='TOTAL'?'text-right font-weight-bold':'text-center'"> {{ props.row.ejercicio}}</div>
                                        </template>
                                    </v-client-table>
                                   
                                   

                                </v-col>
                                <v-col lg="6" style="padding-top:10px;">
                                  <div id="grafica1" style="margin-top:-50px;">

                                        <base-material-chart-card :options="data_grafica1" color="white" type="Bar">
                                            <h5 class="card-title font-weight-light mt-2 ml-2"></h5>
                                        </base-material-chart-card>

                                  </div>
                                
                                </v-col>

                            
                            </v-row>
            
                </v-card-text>
              </div>
            </v-tab-item>
            <v-tab-item :key="'grafica-view-destino'" >
                            <div class="contenedor-tab-reportes">
                              <v-card-text>
                            
                                <v-form ref="form" lazy-validation>
                                  <v-container grid-list-md text-xs-center>
                              
                                    <v-row  dense>
                                      <v-col sm="12" md="2" lg="2">
                                        
                                        <v-menu offset-x ref="menu9" v-model="menu9" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                          <template v-slot:activator="{ on }">
                                            <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial Cargos" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'"
                                              :rules="[rules.required, validaAnio, validaFecha]"></v-text-field>
                                          </template>

                                          <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu9 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu9 = false">
                                              Cancelar
                                            </v-btn>
                                          </v-date-picker>
                                        </v-menu>
                                      </v-col>
                                      <v-col sm="12" md="2" lg="2">
                                        <v-menu offset-x ref="menu10" v-model="menu10" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                          <template v-slot:activator="{ on }">
                                            <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final Cargos" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'"
                                              :rules="[rules.required, validaAnio, validaFecha]"></v-text-field>
                                          </template>
                                          <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu10 = false">
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu10 = false">
                                              Cancelar
                                            </v-btn>
                                          </v-date-picker>
                                        </v-menu>

                                      </v-col>
                                      <v-col sm="2" md="2">
                                          <v-autocomplete v-model="model.destinos_cargos" :items="destinos_aduaneros_cargos"  chips small-chips label="Destinos Aduaneros en Cargos" item-text="clave" item-value="clave" multiple />
                                      </v-col>
                                      <v-col cols="12" sm="2" md="2" lg="2">
                                        
                                        <v-menu offset-x ref="menu11" v-model="menu11" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                          <template v-slot:activator="{ on }" >
                                            <v-text-field v-on="on" v-model="model.fecha_de_a" label="Fecha Inicial Abonos" color="secondary" prepend-icon="event" @blur="model.fecha_de_a = parseDate(model.fecha_de_a)" v-mask="'####-##-##'"
                                                :rules="[rules.required, validaAnio, validaFecha]" ></v-text-field>
                                          </template>

                                          <v-date-picker v-model="model.fecha_de_a" color="secondary" scrollable locale="es-mx" @input="menu11 = false" >
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu11 = false" >
                                              Cancelar
                                            </v-btn>
                                          </v-date-picker>
                                        </v-menu>
                                      </v-col>
                                      <v-col cols="12" sm="2" md="2" lg="2" >
                                        <v-menu offset-x ref="menu12" v-model="menu12" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                                          <template v-slot:activator="{ on }" >
                                            <v-text-field v-on="on" v-model="model.fecha_a_a" label="Fecha Final Abonos" color="secondary" prepend-icon="event" @blur="model.fecha_a_a= parseDate(model.fecha_a_a)" v-mask="'####-##-##'"
                                                :rules="[rules.required, validaAnio, validaFecha]" ></v-text-field>
                                          </template>
                                          <v-date-picker v-model="model.fecha_a_a" color="secondary" scrollable locale="es-mx" @input="menu12 = false" >
                                            <v-spacer />

                                            <v-btn color="secondary" x-small @click="menu12 = false" >
                                              Cancelar
                                            </v-btn>
                                          </v-date-picker>
                                        </v-menu>

                                      </v-col>
                                      <v-col sm="2" md="2">
                                          <v-autocomplete v-model="model.destinos_abonos" :items="destinos_aduaneros_abonos_ctm" chips small-chips label="Destinos Aduaneros en Abonos" item-text="clave" item-value="clave" multiple />
                                      </v-col>
                                    </v-row>
                                    <v-row  dense>
                                          <!-- <v-col cols="12" sm="3" md="3">

                                              <v-autocomplete v-model="valoracion" :items="valoraciones" :hide-no-data="true" :return-object="false" item-text="id" item-value="id" label="Modelo de Valoración">
                                              </v-autocomplete>
                                          </v-col>
                                          <v-col v-if="valoracion=='ULTIMOS 12 MESES'" cols="12" sm="3" md="3" >

                                              <v-autocomplete  v-model="presentacion" :items="presentaciones" :hide-no-data="true" :return-object="false" item-text="id" item-value="id" label="Periodo de Presentación">
                                              </v-autocomplete>
                                          </v-col>
                                      
                                          <v-col v-if="planta_referencia"  cols="12" sm="3" md="3">
                                              <v-autocomplete   v-model="planta" label="Planta Referencia" :items="plantas" :hide-no-data="true" item-text="referencia" item-value="referencia" clearable>
                                              </v-autocomplete>
                                          </v-col>
                                          <v-col v-if="!planta_referencia"  cols="12" sm="3" md="3">
                                          </v-col>
                                          <v-col v-if="valoracion!='ULTIMOS 12 MESES'" cols="12" sm="3" md="3" >
                                          </v-col> -->
                                          <v-spacer></v-spacer>
                                            <v-col cols="12" sm="3" md="3" style="text-align:right">
                                            
                                              <br />
                                                    <v-btn color="success" @click="consultaDestinos">
                                                      <v-icon>done</v-icon>Generar Gráfica
                                                    </v-btn>
                                            </v-col>
                                      </v-row>
                                  
                                  </v-container>

                                </v-form>
                              </v-card-text>
                            
                              <v-card-text>
                              

                           
                            <v-row v-if="data_destinos.impo.length > 0 || data_destinos.expo.length > 0">

                              <v-col lg="12" class="pa-10 pt-0">
                                  <div class="d-inline-flex text-left" style=" z-index:1;    width:100%">
                                      <!-- <span class="overline secondary--text font-weight-light "> -->
                                          <!-- <span v-if="planta_referencia" class="overline primary--text font-weight "> </span> PERÍODO CONSULTADO: DE {{fecha_de2}} A {{fecha_a2}}</span> -->

                                  </div>
                                  <div id="grafica1">
                                      <base-material-chart-card :options="data_grafica2" color="white" type="Bar">
                                          <h5 class="card-title font-weight-light mt-2 ml-2"></h5>
                                      </base-material-chart-card>
                                  </div>
                              </v-col>
                            </v-row>
                            <v-row v-if="data_destinos.impo.length > 0 || data_destinos.expo.length > 0">
                              <v-col lg="6" class="pa-0">
                                    <span class=" mt-2 ml-2 font-weight-bold primary--text">CARGOS</span>
                                    <v-client-table style="margin-top:0px;width:95%" ref="vuetableB" :data="data_destinos.impo" :columns="columns_tableB_cargos" :options="tableB_cargos_options" class="elevation-2 pa-2 footer-hide">
                                        <template slot="noResults">
                                            <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                                        </template>
                                        <template slot="valor" slot-scope="props">
                                            <div :class="props.row.destino=='TOTAL'?'text-right font-weight-bold':'text-right'"> {{ formatNumber(props.row.valor)}}</div>
                                        </template>
                                        <template slot="iva" slot-scope="props">
                                            <div :class="props.row.destino=='TOTAL'?'text-right font-weight-bold':'text-right'"> {{ formatNumber(props.row.iva)}}</div>
                                        </template>
                                        <template slot="ieps" slot-scope="props">
                                            <div :class="props.row.destino=='TOTAL'?'text-right font-weight-bold':'text-right'"> {{ formatNumber(props.row.ieps)}}</div>
                                        </template>
                                        <template slot="destino" slot-scope="props">
                                            <div :class="props.row.destino=='TOTAL'?'text-right font-weight-bold':'text-right'"> {{ props.row.destino}}</div>
                                        </template>
                                    </v-client-table>
                                </v-col>
                                <v-col lg="6" class="pa-0">
                                    <span class=" mt-2 ml-2 font-weight-bold secondary--text">ABONOS</span>
                                    <v-client-table style="margin-top:0px;width:95%" ref="vuetableC" :data="data_destinos.expo" :columns="columns_tableB_cargos" :options="tableB_cargos_options" class="elevation-2 pa-2 footer-hide">
                                      <template slot="noResults">
                                            <v-alert :value="true" icon="info" color="info">No se encontró ningún registro</v-alert>
                                        </template>
                                        <template slot="valor" slot-scope="props">
                                            <div :class="props.row.destino=='TOTAL'?'text-right font-weight-bold':'text-right'"> {{ formatNumber(props.row.valor)}}</div>
                                        </template>
                                        <template slot="iva" slot-scope="props">
                                            <div :class="props.row.destino=='TOTAL'?'text-right font-weight-bold':'text-right'"> {{ formatNumber(props.row.iva)}}</div>
                                        </template>
                                        <template slot="ieps" slot-scope="props">
                                            <div :class="props.row.destino=='TOTAL'?'text-right font-weight-bold':'text-right'"> {{ formatNumber(props.row.ieps)}}</div>
                                        </template>
                                        <template slot="destino" slot-scope="props">
                                            <div :class="props.row.destino=='TOTAL'?'text-right font-weight-bold':'text-right'"> {{ props.row.destino}}</div>
                                        </template>
                                    </v-client-table>
                                </v-col>                            
                            </v-row>
            
                </v-card-text>
              </div>
            </v-tab-item>

            <v-tab-item :key="'cargos-view'" >
              <div class="contenedor-tab-reportes">
                <v-card-text>
                  <v-card-subtitle>
                    <small class="red--text">*Los campos de “FECHA” requeridos para este módulo, se refieren a un periodo definido por rango (ejemplo: del 01-enero-2015 al 31-diciembre-2018).</small>
                  </v-card-subtitle>
                  <v-form ref="form" lazy-validation>
                    <v-container grid-list-md text-xs-center>
                      <v-row row wrap>
                        <v-col sm="12" md="4" lg="4">
                          <v-menu offset-x ref="menu7" v-model="menu7" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }">
                              <v-text-field v-on="on" v-model="model.fecha_de" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de = parseDate(model.fecha_de)" v-mask="'####-##-##'"
                                :rules="[rules.required, validaAnio, validaFecha]"></v-text-field>
                            </template>

                            <v-date-picker v-model="model.fecha_de" color="secondary" scrollable locale="es-mx" @input="menu7 = false">
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu7 = false">
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col sm="12" md="4" lg="4">
                          <v-menu offset-x ref="menu8" v-model="menu8" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }">
                              <v-text-field v-on="on" v-model="model.fecha_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a= parseDate(model.fecha_a)" v-mask="'####-##-##'"
                                :rules="[rules.required, validaAnio, validaFecha]"></v-text-field>
                            </template>
                            <v-date-picker v-model="model.fecha_a" color="secondary" scrollable locale="es-mx" @input="menu8 = false">
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu8 = false">
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>

                        </v-col>
                        <v-col sm="4" md="4">
                            <v-autocomplete v-model="model.destinos_cargos" :items="destinos_aduaneros_cargos"  chips small-chips label="Destinos Aduaneros en Cargos" item-text="clave" item-value="clave" multiple />
                        </v-col>
                      </v-row>
                    </v-container>

                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn color="success" @click="generar_reporte_sqs">
                    <v-icon>done</v-icon>Generar Reporte
                  </v-btn>
                </v-card-actions>
                <v-refresh-button :funcion="cargar"/>
                <v-card-text>
                  <v-client-table ref="vuetable" :data="datos.cargos" :columns="columns" :options="options" class="elevation-1 pa-2">
                    <template slot="noResults">
                      <v-alert :value="true" icon="info" color="info">No se encontro ningun registro</v-alert>
                    </template>

                    <template slot="actions" slot-scope="props">
                      <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadFile(props.row.filename)">
                        <v-icon dark>get_app</v-icon>
                      </v-btn>
                      <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)">
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                    </template>
                  </v-client-table>
                </v-card-text>
              </div>
            </v-tab-item>

            <v-tab-item :key="'abonos_view'" >
              <div class="contenedor-tab-reportes" >
                <v-card-text>
                  <v-card-subtitle>
                     </v-card-subtitle>
                  <v-form ref="form" lazy-validation>
                    <v-container grid-list-md text-xs-center>


                      <v-row row wrap>
                        <v-col cols="12" sm="4" md="4" lg="4" >
                          <v-menu offset-x ref="menu5" v-model="menu5" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="model.fecha_de_a" label="Fecha Inicial" color="secondary" prepend-icon="event" @blur="model.fecha_de_a = parseDate(model.fecha_de_a)" v-mask="'####-##-##'"
                                  :rules="[rules.required, validaAnio, validaFecha]" ></v-text-field>
                            </template>

                            <v-date-picker v-model="model.fecha_de_a" color="secondary" scrollable locale="es-mx" @input="menu5 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu5 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>
                        <v-col cols="12" sm="4" md="4" lg="4" >
                          <v-menu offset-x ref="menu6" v-model="menu6" :close-on-content-click="false" transition="scale-transition" min-width="290px" offset-y>
                            <template v-slot:activator="{ on }" >
                              <v-text-field v-on="on" v-model="model.fecha_a_a" label="Fecha Final" color="secondary" prepend-icon="event" @blur="model.fecha_a_a= parseDate(model.fecha_a_a)" v-mask="'####-##-##'"
                                  :rules="[rules.required, validaAnio, validaFecha]" ></v-text-field>
                            </template>
                            <v-date-picker v-model="model.fecha_a_a" color="secondary" scrollable locale="es-mx" @input="menu6 = false" >
                              <v-spacer />

                              <v-btn color="secondary" x-small @click="menu6 = false" >
                                Cancelar
                              </v-btn>
                            </v-date-picker>
                          </v-menu>

                        </v-col>
                        <v-col sm="4" md="4">
                            <v-autocomplete v-model="model.destinos_abonos" :items="destinos_aduaneros_abonos" chips small-chips label="Destinos Aduaneros en Abonos" item-text="clave" item-value="clave" multiple />
                        </v-col>
                        <!-- <v-col cols="12" md="4" sm="4" lg="4">
                          <v-autocomplete v-model="model.clave_destino" :items="destinos"
                            :hide-no-data="true" :return-object="false" item-text="text" item-value="id"
                            label="Clave de Retorno">
                          </v-autocomplete>
                        </v-col> -->
                      </v-row>
                    </v-container>

                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn color="success" @click="generar_reporte_sqs" >
                    <v-icon>done</v-icon>Generar Reporte
                  </v-btn>
                </v-card-actions>
                <v-card-text>
                  <v-refresh-button :funcion="cargar" />
                  <v-client-table ref="vuetable" :data="datos.abonos" :columns="columns" :options="options" class="elevation-1 pa-2" >
                    <template slot="noResults" >
                      <v-alert :value="true" icon="info" color="info" >No se encontro ningun registro</v-alert>
                    </template>

                    <template slot="actions" slot-scope="props" >
                      <v-btn text icon color="primary" title="Descargar" v-if="props.row.estatus=='Generado Correctamente' && props.row.filename!='' " @click="downloadFile(props.row.filename)" >
                        <v-icon dark>get_app</v-icon>
                      </v-btn>
                      <v-btn text icon color="red" title="Eliminar" v-if="permisoEliminar" @click="eliminarReporte(props.row.id)" >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                    </template>
                  </v-client-table>

                </v-card-text>
              </div>
            </v-tab-item>
          </v-tabs>

        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
  <LoaderFraces ref="fracesLoader" :mensajes="lista_mensajes"></LoaderFraces>
</div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import RefreshButton from "@/components/RefreshButton.vue";
import LoaderFraces from "@/components/LoaderFraces";

var colors_bars = [
    "#08c1ff",
    "#f8cddb",
    "#fffac8",
    "#f4b58f",
    "#eed68f",
    "#aa9499",
    "#aaf0d1",
    "#b2fba5",
    "#ff6961",
    "#ff9899",
    "#ca9bf7"
];

export default {
  components: {
    "v-refresh-button": RefreshButton,
    LoaderFraces
  },
  created: function() {
        let self = this;
        var f_a = new Date();

        let y = f_a.getFullYear();
        let m = f_a.getMonth() + 1;
        let d = f_a.getDate();
       
        if (m < 10)
            m = '0' + m;
        if (d < 10)
            d = '0' + d;

        let fecha = y + "-" + m + "-" +d ;
        this.model.fecha_de = '2015-01-01';
        this.model.fecha_de_a = '2015-01-01';
        this.model.fecha_a = fecha;
        this.model.fecha_a_a = fecha;


    var tipoUsuario = this.$local_storage.get("tipo_usuario");
    if (tipoUsuario == "Soporte" || tipoUsuario == "Super Usuario") {
      this.permisoEliminar = true;
    }
    this.loading = false;
    this.tipo_div = 1;
    this.model.rfc = this.$local_storage.get("rfc");
    this.model.usuario = this.$local_storage.get("id_usuario");
    if (this.planta_referencia)
            this.cargarPlantas();
    // this.consultaPorcentajes();
    this.cargar();
  },
  computed: {

        planta_referencia() {
            return this.$local_storage.get("Modulo16") == 100;
        },

  },
  data: () => ({
    data_destinos:{impo:[],expo:[]},
    columns_tableB_cargos: [
            "destino",
            "valor",
            // "iva",
            // "ieps"
    ],
    tableB_cargos_options: {
            filterable: false,
            filterByColumn: false,
            sortable: [],
            perPage: 100,
            texts: {
                count: ''
            },
            headings: {
                "destino": "DESTINO ADUANERO",
                "valor": "SUMA DE VALOR EN MN",
                "iva": "CRÉDITO FISCAL IVA",
                "ieps": "CRÉDITO FISCAL IEPS",

            }
    },
    data_grafica2: {
      chart: {
          type: "column",
          backgroundColor: null,
          height: 250,
          spacingBottom: 2,
          spacingTop: 2,
          spacingLeft: 2,
          spacingRight: 2,
          marginRight: 2,
          marginLeft: 40,
          marginTop: 2,
          marginBottom: 30,

      },
      credits: {
          enabled: false
      },
      csecondaryits: false,
      title: {
          text: ""
      },
      navigator: {
          yAxis: {
              gridLineColor: '#000'
          }
      },
      colors: colors_bars,
      xAxis: {
          categories: ['CARGOS', 'ABONOS'],
          gridLineWidth: 1,
          title: {
              text: "",
          },
          labels: {
              style: {
                  color: '#000',
                  fontSize: '9px'
              }
          },

      },

      yAxis: {
          allowDecimals: false,
          gridLineWidth: 1,
          minorGridLineWidth: 1,
          minorTicks: true,
          min: 0,
          title: {
              text: "",
          },
          labels: {
              style: {
                  color: '#000',
                  fontSize: '9px'
              }
          },
      },

      tooltip: {
          formatter: function () {
              return (
                  this.series.name + ": " + this.y
              );
          }
      },

      plotOptions: {
          column: {
              stacking: 'normal',
              dataLabels: {
                  enabled: true
              }
          },
          series: {
              borderWidth: 0,
              dataLabels: {
                  enabled: true,
                  format: '{point.series.name}'
              }
          }
      },
      legend: {
          enabled: false
      },
      series: []

      },
    tipo_div:1,
    lista_mensajes: [
            "ESTAMOS PROCESANDO EL PANEL PRINCIPAL..",
            "AGRADECEMOS SU PACIENCIA..",
            "GESTIONANDO INDICADORES DE VALOR..",
            "VERIFICANDO PORCENTAJES DE RETORNO..",
            "ANALIZANDO VALORES POR PERIODO.."
        ],
    meses: ['', 'ENE', 'FEB', 'MAR', 'ABR', 'MAY', 'JUN', 'JUL', 'AGO', 'SEP', 'OCT', 'NOV', 'DIC'],
    data_tableA: [],
    destinos_aduaneros_cargos: ['IN', 'V1', 'E1'],
    destinos_aduaneros_abonos: ['RT', 'V1', 'CTM', 'BM', 'BO', 'L1', 'H1', 'H8', 'A1'],
    destinos_aduaneros_abonos_ctm: ['RT', 'V1', 'BM', 'BO', 'L1', 'H1', 'H8', 'A1'],
    permisoEliminar:false,
    planta: '',
    tipo_periodo: 'Mensual',
        fab: false,
        plantas: [],
        columns_tableA: [
            "ejercicio",
            "cargos",
            "abonos",
            "porcentaje",

        ],
        tableA_options: {
            filterable: false,
            filterByColumn: false,
            sortable: [],
            perPage: 100,
            texts: {
                count: ''
            },
            headings: {
                "ejercicio": "EJERCICIO",
                "cargos": "CARGOS",
                "abonos": "ABONOS",
                "porcentaje": "PORCENTAJE",

            }
        },
        data_grafica1: {
            chart: {
                type: "column",
                backgroundColor: null,
                height: 250,
                spacingBottom: 2,
                spacingTop: 2,
                spacingLeft: 2,
                spacingRight: 2,
                marginRight: 2,
                marginLeft: 40,
                marginTop: 2,
                marginBottom: 30,

            },
            credits: {
                enabled: false
            },
            csecondaryits: false,
            title: {
                text: ""
            },

            navigator: {
                yAxis: {
                    gridLineColor: '#000'
                }
            },
            colors: colors_bars,
            xAxis: {
                categories: [],
                gridLineWidth: 1,
                title: {
                    text: "",
                },
                labels: {
                    style: {
                        color: '#000',
                        fontSize: '9px'
                    }
                },

            },

            yAxis: {
                allowDecimals: false,
                gridLineWidth: 1,
                minorGridLineWidth: 1,
                minorTicks: true,
                min: 0,
                title: {
                    text: "",
                },
                labels: {
                    style: {
                        color: '#000',
                        fontSize: '9px'
                    }
                },
            },

            tooltip: {
                formatter: function () {
                    return false;
                    return (
                        "% " + this.y
                    );
                }
            },

            plotOptions: {
                candlestick: {
                    lineColor: 'secondary'
                },
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: '{point.y:.1f}%'
                    }
                }
            },
            legend: {
                enabled: false
            },
            series: []
        },
    valoraciones: [{
            "id": "EJERCICIO FISCAL"
        }, {
            "id": "ULTIMOS 12 MESES"
        }],
        valoracion: "EJERCICIO FISCAL",
        presentaciones: [{
            "id": "MENSUAL"
        }, {
            "id": "BIMESTRAL"
        }],
        presentacion: "MENSUAL",
    list_activos:[
        {"id":"N","text":"No"}, //No Activo Fijos
        {"id":"S","text":"Si"}, //Activo Fijo
        {"id":"","text":"Todos"}],
    breadcrumbs: [{
        text: "Inicio",
        disabled: false,
        to: "/home"
      },
      {
        text: "Auditorías",
        disabled: true,
        to: ""
      },
      {
        text: "Porcentajes de Retorno",
        disabled: true,
        to: ""
      }
    ],
    datos: {
      cargos:[],
      abonos:[]
    },
    columns: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error", "actions"],
    options: {
      filterable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],
      sortable: ["id", "fecha_solicitud", "usuario_email", "nombre_reporte", "criterio", "fecha_generacion", "estatus", "error"],

      headings: {
        id: "No. Proceso",
        fecha_solicitud: "Solicitado",
        usuario_email: "Usuario",
        nombre_reporte: "Reporte",
        criterio: "Criterio de Búsqueda",
        fecha_generacion: "Generado",
        estatus: "Estatus",
        error: "Error",
        actions: "Descargar"
      }
    },
    loading: false,
    listado:"",
    model: {
      rfc: "",
      usuario: "",
      fecha_de: "",
      fecha_a: "",
      fecha_de_a: "",
      fecha_a_a: "",
      reporte_url: "",
      nombre_reporte: "",
      tipo: "",
      activo:"",
      clave_destino:"",
      destinos_cargos:['IN', 'V1', 'E1'],
      destinos_abonos:['RT', 'V1', 'CTM']
    },
    rules: {
      required: v => !!v || "Este campo es requerido",
      numeric: value => {
        const pattern = /^[\d]*$/;
        return pattern.test(value) || "Solo se permiten números";
      }
    },
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
    menu10: false,
    menu11: false,
    menu12: false

  }),
  methods: {
    cargarPlantas: async function () {

        let data = {
            cliente: this.$local_storage.get("id_cliente"),
        };
        await axios.post(this.$hostname + "catalogos/referencias/get_referencias/", data)
            .then(res => {
                if (typeof res.data !== "undefined") {
                    this.plantas = res.data;

                }
            })
            .catch(err => {
                console.log();
            });
    },
    formatNumber: function (x) {
            if (x == undefined) return 0;
            x = x.toString();
            var pattern = /(-?\d+)(\d{3})/;
            while (pattern.test(x)) x = x.replace(pattern, "$1,$2");
            return x;
        },
    consultaDestinos: function () {

          this.$refs.fracesLoader.show('ESPERE UN MOMENTO POR FAVOR ..');
          this.data_destinos = {impo:[],expo:[]};
          this.data_grafica2.series = [];

          let self = this;
          let total_cargos = 0;
          let total_abonos = 0;

          this.data_tableA = [];
          let data = {
              rfc: this.$local_storage.get("rfc"),
              fecha_cargo: this.model.fecha_a,
              fecha_de: this.model.fecha_de,
              destinos_cargos: this.model.destinos_cargos,
              fecha_abono: this.model.fecha_a_a,
              fecha_de_abono: this.model.fecha_de_a,
              destinos_abonos: this.model.destinos_abonos,
          };
          if (this.planta != '') {
          }

          if (this.valoracion == 'EJERCICIO FISCAL') {
              axios.post(this.$apiSA31 + "soluciona31/reportes/cargos_destino_tipo/", data)
                  .then(res => {
                      if (typeof res.data !== "undefined") {
                          let cargos = res.data;
                          self.data_destinos = cargos;
                          cargos.impo.forEach(x => {
                            self.data_grafica2.series.push({
                                name: x.destino,
                                data: [parseInt(x.valor), '']
                            }, );
                          });
                          cargos.expo.forEach(x => {
                            self.data_grafica2.series.push({
                                name: x.destino,
                                data: ['',parseInt(x.valor)]
                            }, );
                          });
                          // self.llenarGrafica1();
                      }
                  })
                  .catch(err => {
                      console.log(err);
                      this.loading = false;
                  }).then(res => {
                      this.dialog = false;
                      self.$refs.fracesLoader.hide();
                  });

          }
          },
    consultaPorcentajes: function () {

          this.$refs.fracesLoader.show('ESPERE UN MOMENTO POR FAVOR ..');
          let self = this;
          let total_cargos = 0;
          let total_abonos = 0;

          this.data_tableA = [];
          let data_cargos = {
              rfc: this.$local_storage.get("rfc"),
              fecha_cargo: this.model.fecha_a,
              fecha_de: this.model.fecha_de,
              destinos: this.model.destinos_cargos 
          };
          let data_abonos = {
              rfc: this.$local_storage.get("rfc"),
              fecha_abono: this.model.fecha_a_a,
              fecha_de: this.model.fecha_de_a,
              destinos: this.model.destinos_abonos
          };
          if (this.planta != '') {
              data_cargos = {
                  rfc: this.$local_storage.get("rfc"),
                  fecha_cargo: this.model.fecha_a,
                  fecha_de: this.model.fecha_de,
                  destinos: this.model.destinos_cargos,
                  planta: this.planta
              }
              data_abonos = {
                  rfc: this.$local_storage.get("rfc"),
                  fecha_abono: this.model.fecha_a_a,
                  fecha_de: this.model.fecha_de_a,
                  destinos: this.model.destinos_abonos,
                  planta: this.planta
              }

          }

          if (this.valoracion == 'EJERCICIO FISCAL') {
              axios.post(this.$apiSA31 + "soluciona31/reportes/cargos_anio/", data_cargos)
                  .then(res => {
                      if (typeof res.data !== "undefined") {
                          let cargos = res.data;
                          cargos = res.data.sort(function (a, b) {
                              return parseInt(b.anio) - parseInt(a.anio);
                          });
                          console.log(cargos);
                          axios.post(this.$apiSA31 + "soluciona31/reportes/abonos_anio/", data_abonos)
                              .then(res => {
                                  if (typeof res.data !== "undefined") {
                                      cargos.forEach(function (c) {
                                          self.data_tableA.push({
                                              "ejercicio": c.anio,
                                              "cargos": parseInt(c.valor),
                                              "abonos": "0",
                                              "porcentaje": "0",

                                          });
                                      });
                                      let abonos = res.data;
                                      abonos.forEach(function (a) {
                                          let encontrado = self.data_tableA.filter(item => {
                                              return item.ejercicio == a.anio
                                          });

                                          if (encontrado.length > 0) {
                                              encontrado[0].abonos = parseInt(a.valor);
                                              encontrado[0].porcentaje = parseInt((parseFloat(encontrado[0].abonos) / parseFloat(encontrado[0].cargos)) * 100);
                                          } else {
                                              self.data_tableA.push({
                                                  "ejercicio": a.anio,
                                                  "cargos": "0",
                                                  "abonos": parseInt(a.valor),
                                                  "porcentaje": "0",

                                              });
                                          }

                                      });
                                      self.llenarGrafica1();

                                  }
                              })
                              .catch(err => {
                                  console.log(err);
                                  this.loading = false;
                              }).then(res => {
                                  this.dialog = false;
                                  this.loading = false;
                                  self.$refs.fracesLoader.hide();
                              });

                      }
                  })
                  .catch(err => {
                      console.log(err);
                      this.loading = false;
                  }).then(res => {
                      this.dialog = false;
                      self.$refs.fracesLoader.hide();
                  });

          } else {
              axios.post(this.$apiSA31 + "soluciona31/reportes/cargos_mes/", data_cargos)
                  .then(res => {
                      if (typeof res.data !== "undefined") {
                          let cargos = res.data;

                          axios.post(this.$apiSA31 + "soluciona31/reportes/abonos_mes/", data_abonos)
                              .then(res => {
                                  if (typeof res.data !== "undefined") {

                                      let abonos = res.data;
                                      let cuenta = 0;
                                      cargos.forEach(function (c) {
                                          if (self.presentacion == "BIMESTRAL" && self.valoracion == "ULTIMOS 12 MESES" ) {
                                              if (c.mes % 2 == 0) {
                                                    var exists_bimestre = self.data_tableA.filter(item => {
                                                        return item.ejercicio == c.anio + '-' + self.meses[c.mes - 1] + '-' + self.meses[c.mes]
                                                    });
                                                } else {
                                                    var exists_bimestre = self.data_tableA.filter(item => {
                                                        return item.ejercicio == c.anio + '-' + self.meses[c.mes] + '-' + self.meses[c.mes + 1]
                                                    });
                                                }
                                              if(cuenta < 6 || exists_bimestre.length > 0){ 
                                                if (c.mes % 2 == 0) {
                                                    self.data_tableA.push({

                                                        "ejercicio": c.anio + '-' + self.meses[c.mes - 1] + '-' + self.meses[c.mes],
                                                        "cargos": parseInt(c.valor),
                                                        "abonos": "0",
                                                        "porcentaje": "0",

                                                    });
                                                    total_cargos += parseInt(c.valor);
                                                    cuenta +=1;
                                                } else {
                                                    let encontrado2 = self.data_tableA.filter(item => {
                                                        return item.ejercicio == c.anio + '-' + self.meses[c.mes] + '-' + self.meses[c.mes + 1]
                                                    });

                                                    if (encontrado2.length > 0) {
                                                        encontrado2[0].cargos = parseInt(encontrado2[0].cargos) + parseInt(c.valor);
                                                        encontrado2[0].porcentaje = parseInt((parseFloat(encontrado2[0].abonos) / parseFloat(encontrado2[0].cargos)) * 100);
                                                        total_cargos += parseInt(c.valor);
                                                    } else {
                                                        self.data_tableA.push({

                                                            "ejercicio": c.anio + '-' + self.meses[c.mes] + '-' + self.meses[c.mes + 1],
                                                            "cargos": parseInt(c.valor),
                                                            "abonos": "0",
                                                            "porcentaje": "0",

                                                        });
                                                        total_cargos += parseInt(c.valor);
                                                        cuenta +=1;
                                                    }

                                                }
                                              }

                                          } else {
                                              total_cargos += parseInt(c.valor);
                                              if(cuenta < 12)
                                              self.data_tableA.push({

                                                  "ejercicio": c.anio + '-' + self.meses[c.mes],
                                                  "cargos": parseInt(c.valor),
                                                  "abonos": "0",
                                                  "porcentaje": "0",

                                              });
                                              cuenta +=1;
                                          }

                                      });
                                      abonos.forEach(function (a) {

                                          if (self.presentacion == "BIMESTRAL" && self.valoracion == "ULTIMOS 12 MESES") {
                                              if (a.mes % 2 == 0) {
                                                  let encontrado = self.data_tableA.filter(item => {
                                                      return item.ejercicio == a.anio + '-' + self.meses[a.mes] + '-' + self.meses[a.mes - 1]
                                                  });

                                                  if (encontrado.length > 0) {
                                                      encontrado[0].abonos = parseInt(encontrado[0].abonos) + parseInt(a.valor);
                                                      encontrado[0].porcentaje = parseInt((parseFloat(encontrado[0].abonos) / parseFloat(encontrado[0].cargos)) * 100);
                                                      total_abonos += parseInt(a.valor);
                                                  }
                                              } else {
                                                  let encontrado = self.data_tableA.filter(item => {
                                                      return item.ejercicio == a.anio + '-' + self.meses[a.mes] + '-' + self.meses[a.mes + 1]
                                                  });

                                                  if (encontrado.length > 0) {
                                                      encontrado[0].abonos = parseInt(a.valor);
                                                      encontrado[0].porcentaje = parseInt((parseFloat(encontrado[0].abonos) / parseFloat(encontrado[0].cargos)) * 100);
                                                      total_abonos += parseInt(a.valor);
                                                  }
                                              }
                                          } else {
                                              let encontrado = self.data_tableA.filter(item => {
                                                  return item.ejercicio == a.anio + '-' + self.meses[a.mes]
                                              });

                                              if (encontrado.length > 0) {
                                                  total_abonos += parseInt(a.valor);
                                                  encontrado[0].abonos = parseInt(a.valor);
                                                  encontrado[0].porcentaje = parseInt((parseFloat(encontrado[0].abonos) / parseFloat(encontrado[0].cargos)) * 100);
                                              }
                                          }

                                      });
                                      self.llenarGrafica1();
                                      if (self.valoracion == "ULTIMOS 12 MESES") {
                                          self.data_tableA.push({

                                              "ejercicio": 'TOTAL',
                                              "cargos": total_cargos,
                                              "abonos": total_abonos,
                                              "porcentaje": parseInt((total_abonos / total_cargos) * 100),

                                          });
                                      }

                                  }
                              })
                              .catch(err => {
                                  console.log(err);
                                  this.loading = false;
                              }).then(res => {
                                  this.dialog = false;
                                  this.loading = false;
                                  self.$refs.fracesLoader.hide();
                              });

                      }
                  })
                  .catch(err => {
                      console.log(err);
                      this.loading = false;
                  });
          }

          },
    async llenarGrafica1() {
          let self = this;
          let data = [];
          self.data_grafica1.xAxis.categories = [];
         
          self.data_grafica1.xAxis.categories = [];
          self.data_tableA.forEach(function (x) {
              data.push({
                  y: parseInt(x.porcentaje),
                  name: x.ejercicio
              })
              self.data_grafica1.xAxis.categories.push(x.ejercicio);
          });

          self.data_grafica1.series[0] = {
              data: data,
              colorByPoint: true
          };

          },
    cargar: function() {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      let data = {
        rfc: this.model.rfc,
        tipo: this.tipo_div == 1 ? 'SA31_Cargos_Reporteador' : 'SA31_Abonos_Reporteador'
      };
      axios.post(this.$apiSA31 + "soluciona31/reportes/get_reportes/", data)
        .then(res => {
          if (typeof res.data !== "undefined") {
            this.datos[this.tipo_div == 1 ? 'cargos' : 'abonos'] = res.data;
            this.datos[this.tipo_div == 1 ? 'cargos' : 'abonos'].sort(function(a, b) {
              //Ordenar por fecha más reciente
              return new Date(b.fecha_solicitud) - new Date(a.fecha_solicitud)
            });
            for (var k in this.datos[this.tipo_div == 1 ? 'cargos' : 'abonos']) {
              this.datos[this.tipo_div == 1 ? 'cargos' : 'abonos'][k].fecha_solicitud = this.parseDate(this.datos[this.tipo_div == 1 ? 'cargos' : 'abonos'][k].fecha_solicitud);
              this.datos[this.tipo_div == 1 ? 'cargos' : 'abonos'][k].fecha_generacion = this.parseDate(this.datos[this.tipo_div == 1 ? 'cargos' : 'abonos'][k].fecha_generacion);
              this.datos[this.tipo_div == 1 ? 'cargos' : 'abonos'][k].estatus = this.getEstatus(this.datos[this.tipo_div == 1 ? 'cargos' : 'abonos'][k].estatus);
              this.datos[this.tipo_div == 1 ? 'cargos' : 'abonos'][k].criterio = this.getCriterioPredeterminados(this.datos[this.tipo_div == 1 ? 'cargos' : 'abonos'][k].criterio);
            }
          }
        })
        .catch(err => {

        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    getEstatus: function(estatus) {
      var arr_estatus = ["Pendiente", "Encolado", "Generado Correctamente", "Con Errores",
        "No Recuperable", "Token Incorrecto", "Reprogramado", , "Pendiente AA"
      ];
      if (estatus in arr_estatus)
        return arr_estatus[estatus];
      else
        return "N/A";
    },
    getCriterioPredeterminados: function(criterio) {
      try {
        if (criterio != undefined && criterio.toString().trim() != "") {
          var params = JSON.parse(criterio);

            if (params.lista != undefined && params.lista.length > 0) {
              return "Buscado por lista de pedimentos: " + params.lista.length;
            } else if (params.numero_pedimento && params.numero_pedimento != ""){
              return "Pedimento: " + params.numero_pedimento;
            }else {
              var txt = "";
              if (params.fecha_de && params.fecha_de != "")
                  txt += "Fecha De: " + params.fecha_de+", ";
              if (params.fecha_a && params.fecha_a != "")
                  txt += " Fecha A: " + params.fecha_a+", ";
              if (params.fraccion && params.fraccion != "")
                  txt += " Fracción: " + params.fraccion+", ";
              if (params.activo && params.activo != "")
                  txt += " Activo: " + params.activo+", ";
              if (params.clave_documento && params.clave_documento != "")
                  txt += " Clave Doc: " + params.clave_documento;
              return txt;
            }


        } else {
          return "N/A";
        }
      } catch (error) {
        console.log(error);
        return "N/A-error";
      }

    },
    validaDiasPreview: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
        if (Math.abs(diferencia) > 31)
          return "Periodo máximo de consulta 31 dias. Favor de verificar."
      }
      return true;
    },
    validaDias: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
      }
      return true;
    },
    formatNumberDec: function(numero, decimales){
        if (numero == undefined || numero == null || numero == "")
            numero = 0;
        numero = Number(numero);
        if (isNaN(numero)){
            return "";
        } else
            return (numero).toFixed(decimales).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },
    validaFecha: function(fecha) {
      if (fecha == "Invalid date")
        return "Fecha no válida."
      else
        return true;
    },
    validaAnio: function() {
      if (this.model.fecha_de != "" && this.model.fecha_a != "") {
        var inicio = moment(this.model.fecha_de, "YYYY-MM-DD");
        var fin = moment(this.model.fecha_a, "YYYY-MM-DD");
        var diferencia = fin.diff(inicio, 'days')
        if (diferencia < 0)
          return "La Fecha Final no debe ser menor a la Fecha Inicial."
      }
      return true;
    },
    parseDate(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD");
    },
    parseDateTime(date) {
      if (!date) return null;
      return moment(String(date)).format("YYYY-MM-DD HH:mm:ss");
    },
    generar_reporte_sqs() {
      if (!this.$refs.form.validate()) {
        //Alguna operación o mensaje
      } else {
        this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
        var data = this.model;

        // llenar los campos con tipo de reporte y eso
        if(this.tipo_div == 1) {
          data['reporte_url'] =  "/soluciona31/reportes/cargos/";
          data['nombre_reporte'] = "Cargos Reporteador";
          data['tipo'] = "SA31_Cargos_Reporteador";
        } else {
          data['reporte_url'] =  "/soluciona31/reportes/rpt_abonos_folio/";
          data['nombre_reporte'] = "Abonos Reporteador";
          data['tipo'] = "SA31_Abonos_Reporteador";
          data['activo'] = 'N';
          data.fecha_de = this.model.fecha_de_a;
          data.fecha_a = this.model.fecha_a_a;
        }

        axios({
            method: "post",
            url: this.$apiSA31 + "soluciona31/reportes/save_reporte/",
            data: data
          })
          .then(response => {
            this.model.activo = "";
            this.$swal({
              type: "success",
              title: "Operación Exitosa",
              text: "El reporte se está generando. Cuando esté listo recibirá una notificación",
              footer: ""
            });
          })
          .catch(error => {
            this.model.activo = "";
            let mensaje;
            var titulo = "¡Operación no Permitida!";
            var tipo = "error";
            if (typeof error.response !== "undefined") {
              mensaje = error.response.data.mensaje;
              if (error.response.status == 406) {
                titulo = "¡Ya existe un reporte en proceso!";
                tipo = "info";
              }
            } else {
              mensaje = "Ocurrió un error al generar el reporte";
            }
            this.$swal({
              type: tipo,
              title: titulo,
              text: mensaje,
              footer: ""
            });
          }).then(() => {
            this.model.activo = "";
            this.cargar(this.tipo_div);
            this.$root.$dialogLoader.hide();
          });
      }
    },
    downloadFile: function(key) {
      this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
      var datos = {
        id: key,
        bucket: "production.econnect.ds"
      }
      axios.post(this.$hostname + 's3/download_url/', datos)
        .then((res) => {
          if (typeof res.data !== 'undefined') {
            var a = document.createElement("a");
            document.body.appendChild(a);
            a.style = "display: none";
            a.href = res.data.mensaje;
            a.target = '_blank';
            a.click();
            a.parentNode.removeChild(a);

          } else {
            this.$swal({
              type: "error",
              title: "¡Operación no Permitida!",
              text: "No se encontró el archivo a descargar. Intente nuevamente por favor.",
              footer: '',
            });
          }
        })
        .catch((error) => {
          var mensaje = "Ocurrió un error al descargar el archivo";
          if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
            mensaje = error.response.data.mensaje;
          this.$swal({
            type: "error",
            title: "¡Operación no Permitida!",
            text: mensaje,
            footer: '',
          });
          console.log(error);
        }).then(() => {
          this.$root.$dialogLoader.hide();
        });
    },
    eliminarReporte: function(idreporte) {
      this.$swal({
        type: "info",
        title: "Cuidado",
        text: "¿Está seguro de eliminar el reporte con No. Proceso: " + idreporte + "?",
        footer: "",
        showCancelButton: true,
        cancelButtonColor: "#d33",
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar"
      }).then(result => {
        if (result.value) {
          this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
          var datos = {
            id_reporte: idreporte,
          }
          axios.post(this.$apiSA31 + 'soluciona31/reportes/eliminar_reporte/', datos)
            .then((res) => {
              this.$swal({
                type: "success",
                title: "Operación Exitosa",
                text: "El reporte se eliminó correctamente",
                footer: ""
              });
            })
            .catch((error) => {
              this.$swal({
                type: "error",
                title: "¡Operación no Permitida!",
                text: "Ocurrió un error al eliminar el reporte. Favor de comunicarse con soporte.",
                footer: '',
              });
              console.log(error);
            }).then(() => {
              this.$root.$dialogLoader.hide();
              this.cargar();
            });
        }
      });
    },


  },
};
</script>
<style scoped>
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active),
.theme--light.v-tabs>.v-tabs-bar .v-tab:not(.v-tab--active)>.v-icon,
.theme--light.v-tabs>.v-tabs-bar .v-tab--disabled {
  color: black;
  font-size: small;
  background-color: #EEEEEE;
  padding: 0px;
}

.v-tabs .v-tabs-bar .v-tab.v-tab--active {
  color: white;
  font-size: small;
  background-color: #df7205;
  padding: 0px;
  font-weight: bold;

}

.v-tabs-slider-wrapper {
  left: 0 !important;
}
</style>
